module.exports = __webpack_public_path__ + "static/rig-worker-631e3814a18f5185b98dcdaf5148bcf7.jpg";